import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52b15d32"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "category-items" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CategoryItem = _resolveComponent("CategoryItem")!
  const _component_BucketTotal = _resolveComponent("BucketTotal")!
  const _component_MoveEdit = _resolveComponent("MoveEdit")!
  const _component_BucketItem = _resolveComponent("BucketItem")!
  const _component_Guidance = _resolveComponent("Guidance")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categorys, (item, i) => {
        return (_openBlock(), _createBlock(_component_CategoryItem, {
          key: item.id,
          title: item.name,
          icon: item.icon,
          backgroundColor: _ctx.backgroundPalette[i],
          isSelected: item.id === _ctx.selectedCategoryId,
          onClick: ($event: any) => (_ctx.onCategoryClickHandler(item.id))
        }, null, 8, ["title", "icon", "backgroundColor", "isSelected", "onClick"]))
      }), 128))
    ]),
    _createVNode(_component_BucketTotal, {
      total: _ctx.count.total,
      completed: _ctx.count.checked,
      remaining: _ctx.count.notChecked
    }, null, 8, ["total", "completed", "remaining"]),
    _createElementVNode("div", null, [
      _createVNode(_component_MoveEdit)
    ]),
    _createElementVNode("div", null, [
      (_ctx.bucketList.length)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.bucketList, (item) => {
            return (_openBlock(), _createBlock(_component_BucketItem, {
              key: item.id,
              data: item,
              onClick: _withModifiers((event) => _ctx.onBucketItemClickHandler(event, item.id), ["stop"]),
              onOnDeleteHandler: _ctx.onDeleteHandler,
              onOnCheckboxHandler: _ctx.onCheckboxHandler
            }, null, 8, ["data", "onClick", "onOnDeleteHandler", "onOnCheckboxHandler"]))
          }), 128))
        : (_openBlock(), _createBlock(_component_Guidance, { key: 1 }))
    ])
  ]))
}